/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import NutritionOrderItem from './nutrition-order-item';
import NutritionOrderItemDetail from './nutrition-order-item-detail';
import NutritionOrderItemUpdate from './nutrition-order-item-update';
import NutritionOrderItemDeleteDialog from './nutrition-order-item-delete-dialog';

const NutritionOrderItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<NutritionOrderItem />} />
    <Route path="new" element={<NutritionOrderItemUpdate />} />
    <Route path=":id">
      <Route index element={<NutritionOrderItemDetail />} />
      <Route path="edit" element={<NutritionOrderItemUpdate />} />
      <Route path="delete" element={<NutritionOrderItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default NutritionOrderItemRoutes;
